import { QueryKey, UseQueryOptions, useQuery } from 'react-query';

import { getPeople } from 'services/people';
import { IPeopleFilters } from 'store/reducers/people/people-reducer';

export default function usePeople(
  filters?: IPeopleFilters & { groupings?: { type: string; uuid: string }[] },
  per_page?: number,
  teaming?: boolean,
  scope?: { type: string; uuid: string },
  account_holders?: boolean,
  options?: Omit<UseQueryOptions<any, Error, any, QueryKey>, 'queryKey'>
) {
  return useQuery<any, Error>(
    [`people-index`, filters, teaming, scope?.type, scope?.uuid, account_holders],
    () => {
      return getPeople(filters, per_page, teaming, scope?.type, scope?.uuid, account_holders).then(
        (response) => {
          if (!response.ok) {
            throw new Error(response.originalError.message);
          }
          return response.data;
        }
      );
    },
    {
      ...options,
      cacheTime: 0,
      staleTime: 0,
    }
  );
}
